import React, { PureComponent } from 'react';
import { merge } from 'lodash';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import classnames from 'classnames';
import './styles.scss';

const STYLE = {
  content: {
    background: null,
  },

  overlay: {
    backgroundColor: 'rgba(161, 170, 177, 0.5)',
  },
};

export default class Modal extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    shouldCloseOnEsc: PropTypes.bool,
    shouldCloseOnOverlayClick: PropTypes.bool,
    style: PropTypes.object,
  };

  static defaultProps = {
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    style: {},
  };

  state = {
    open: !!this.props.open,
  };

  element = document.body;

  closeModal = () => {
    this.setState({ open: false });
    this.props.onClose && this.props.onClose();
  };

  componentWillReceiveProps(nextProps) {
    if (this.state.open !== nextProps.open) {
      this.setState({ open: nextProps.open });
    }
  }

  render() {
    const { children, className, style, shouldCloseOnEsc, shouldCloseOnOverlayClick, ...props } = this.props;
    const { open } = this.state;

    return (
      <ReactModal
        appElement={this.element}
        className={classnames('react-modal-container', className)}
        isOpen={open}
        onRequestClose={this.closeModal}
        shouldCloseOnEsc={shouldCloseOnEsc}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        style={merge(STYLE, style)}
        {...props}
      >
        {children}
      </ReactModal>
    );
  }
}
